<style scoped>
    @import url("../../../styles/smartControl/cardReceita.scss");
</style>

<template>
    <div class="box_cardReceita mt-2">

        <div class="linhaZero">
            <v-chip size="x-small" color="white">{{ program.program }}</v-chip>
            <v-chip v-if="program.name == null" class="ml-1" size="x-small" color="white">
                Programa sem nome
            </v-chip>
            <v-chip v-else class="ml-1" size="x-small" color="white">
                {{ program.name }}
            </v-chip>
            <v-icon class="ml-1">mdi-note-edit</v-icon>
        </div>

        <div class="linhaUm">
            <div class="colUm">
                <span :style="{'color':'#F39C12'}">active:
                    <span :style="{'color':'white'}">{{ program.active }}</span>
                </span>
            </div>

            <div class="colDois">
                <span :style="{'color':'#F39C12'}">groups:
                    <span :style="{'color':'white'}">{{ program.groups }}</span>
                </span>
            </div>

            <div class="colDois">
                <span :style="{'color':'#F39C12'}">fertilicerFormula:
                    <span :style="{'color':'white'}">{{ program.fertilicerFormula }}</span>
                </span>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: ['program'],
}
</script>
